import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import classnames from 'classnames'
import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import useSiteMetadata from '../../../hooks/useSiteMetadata'
import useUserCategory from '../../../hooks/useUserCategory'
import { DropShipInput } from '../../../lib/cart/constants'
import { FormValues } from '../../../lib/cart/types'
import useStyles from './styles/dropShip'

export interface DropShipFormProps {
  defaultValues: FormValues.DropShip
}

const DropShipForm: React.FC<DropShipFormProps> = ({ defaultValues }) => {
  const classes = useStyles()
  const { control, errors } = useFormContext<FormValues.DropShip>()
  const { userCategory } = useUserCategory()
  const { featureFlags } = useSiteMetadata() ?? {}
  const showDropShip = useMemo(
    () => userCategory === 'practitioner' && featureFlags?.practitionerDropShip,
    [featureFlags, userCategory],
  )

  return showDropShip ? (
    <Grid
      className={classes.dropShipForm}
      container
      spacing={2}
      alignItems="center"
      justify="center"
    >
      <Grid item xs={12} sm={12}>
        <Controller
          control={control}
          defaultValue={defaultValues.dropShip}
          name="dropShip"
          render={({ onChange, onBlur, value, name }) => (
            <FormControl error={!!errors.dropShip} component="fieldset">
              <FormLabel className={classes.dropShipLabel}>
                <Typography variant="body2">
                  Are you sending this package to a patient address or someone other than yourself?*
                </Typography>
              </FormLabel>
              <RadioGroup
                className={classes.radioGroup}
                name={name}
                onBlur={onBlur}
                onChange={(e) => onChange(e.target.value)}
                row
                value={value}
              >
                <FormControlLabel
                  className={classnames(classes.radio, {
                    selected: value === '1',
                  })}
                  control={<Radio checkedIcon={<CheckCircleIcon />} />}
                  label="NO"
                  value={DropShipInput.NO}
                />
                <FormControlLabel
                  className={classnames(classes.radio, {
                    selected: value === '2',
                  })}
                  control={<Radio checkedIcon={<CheckCircleIcon />} />}
                  label="YES"
                  value={DropShipInput.YES}
                />
              </RadioGroup>
            </FormControl>
          )}
          rules={{ required: true }}
        />
      </Grid>
    </Grid>
  ) : null
}

export default DropShipForm
